<br/>
<br/>
<br/>
<form #loginForm="ngForm">
    <mat-card class="pre-card">
        <mat-card-header>
            <mat-card-title>        
                <mat-toolbar color="primary" class="pre-title">
                    <img src="assets/img/udg_blanc_transparent_small.png" class="pre-titol-logo">
                    <span i18n="@@90ae0645ce3c74b70e7cfb7260d9f70593d690c8">Trasllat</span>
                    <span class="pre-spacer"></span>
                    <div class="button-row">
                        <a mat-button *ngFor="let l of dataService.languages_app" href="../{{localize(l.name)}}" target="_self" style="min-width: 10px">{{l.name | uppercase}}</a>
                    </div>              
                </mat-toolbar>                
            </mat-card-title>
        </mat-card-header>
        <mat-card-content class="pre-form">
            <p *ngIf="!initialized" i18n>Carregant...</p>
            <mat-grid-list *ngIf="initialized" cols="2" rows="3" rowHeight="100px">
            <mat-grid-tile colspan="2">
                <mat-form-field class="pre-field">
                    <input matInput placeholder="Pla" disabled [value]="login.oferta?.name" *ngIf="!escollirOferta" name="ofertaFixada">
                    <mat-select placeholder="Estudi al qual us voleu traslladar" *ngIf="escollirOferta" [(ngModel)]="login.oferta" name="ofertaSeleccionada" required  i18n-placeholder="@@abc0ff71d6c9289b7e376efbe99dcd3f1b4326f6">
                        <mat-option *ngFor="let o of ofertes" [value]="o">
                        {{ o.name }}
                        </mat-option>
                    </mat-select>                  
                </mat-form-field>                  
            </mat-grid-tile>
            <mat-grid-tile>
                <mat-form-field class="pre-field">
                    <input type="text" matInput placeholder="Document identificatiu" [(ngModel)]="login.documentIdentificatiu" name="documentIdentificatiu" 
                    pattern="[A-Za-z0-9]+" required  i18n-placeholder>
                    <mat-error i18n="@@ErrorDocumentIdentificatiu">
                        El document identificatiu no és vàlid. Només pot contenir números i lletres. Cal ignorar els espais, guions, barres i altres caràcters estranys.
                    </mat-error>
                </mat-form-field>  
            </mat-grid-tile>
            <mat-grid-tile>                
                <mat-form-field class="pre-field">
                    <input type="text" matInput placeholder="Data de naixement" [(ngModel)]="login.dataNaixement" name="dataNaixement" 
                    pattern="(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}" required i18n-placeholder="@@DataNaixementLogin">
                </mat-form-field>                                     
            </mat-grid-tile>
            <mat-grid-tile colspan="2">
                <mat-checkbox class="pre-controls-left" required name="acceptacioLopd" [(ngModel)]="login.acceptaLopd"
                    matTooltip="Informació bàsica sobre protecció de dades. Responsable del tractament: Universitat de Girona. Finalitat: oferir el servei de trasllat d’expedient. Legitimació: les dades es tracten per a la prestació dels serveis docents (art. 6.1.b RGPD) i en compliment d’obligacions legals (art. 6.1.c RGPD). Destinataris: les dades es comuniquen a administracions públiques competents en la matèria d’ensenyament superior i a institucions i empreses amb què la UdG té convenis de col·laboració. Drets de les persones interessades: es poden exercir els drets d’accés, rectificació, supressió, oposició al tractament i sol·licitud de la limitació del tractament adreçant-se a la Universitat de Girona. Podeu consultar informació addicional i detallada sobre protecció de dades a www.udg.edu/protecciodades."
                    matTooltipPosition="below" i18n i18n-matTooltip="@@c34d3d3b3d8b4ee6326f46e64d15102472f21c34">Accepto les condicions de protecció de dades <i class="material-icons">info_outline</i></mat-checkbox>         
            </mat-grid-tile>           
            </mat-grid-list>
        </mat-card-content>  
        <mat-card-actions align="end">
            <button mat-raised-button color="primary" (click)="inicia()" [disabled]="!loginForm.form.valid" i18n>INICIA</button>
        </mat-card-actions>  
    </mat-card>
</form>


// WEBPACK FOOTER //
// ./src/app/login/login.component.html